module.exports = __webpack_public_path__ + "img/umn.5aa2a3d9.jpg";